module.exports = __webpack_public_path__ + "static/media/TheSustanabilityAcademy-LandscapeWhite.11de33f5.png";